export default __webpack_public_path__ + "sounds/95b5e3a875f4f0163796ca098597fb75.mp3";